<!-- DATE + FIXED RANGE -->
<div *ngIf="mode === 'date' || mode === 'fixed'" class="frp">
  <button
    *ngIf="!inline"
    type="button"
    class="frp-trigger"
    (click)="toggleOpen(); $event.stopPropagation()"
  >
    <span class="frp-trigger__value">{{ displayValue || placeholder }}</span>
    <svg
      class="frp-trigger__ic"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="16"
        rx="3"
        stroke="currentColor"
        stroke-width="1.6"
      ></rect>
      <path d="M3 10.5H21" stroke="currentColor" stroke-width="1.6"></path>
      <path
        d="M8 3V7M16 3V7"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
      ></path>
    </svg>
  </button>

  <div
    #panelRef
    *ngIf="inline || open"
    class="frp-pop"
    [ngStyle]="!inline ? panelStyles : null"
    (click)="$event.stopPropagation()"
  >
    <div class="frp-head">
      <button type="button" class="frp-nav" (click)="prevMonth()">‹</button>

      <div class="frp-title">
        {{ monthLabel }}
      </div>

      <button type="button" class="frp-nav" (click)="nextMonth()">›</button>
    </div>

    <div class="calendar">
      <div class="frp-week">
        <span *ngFor="let wd of weekdays">
          {{ wd }}
        </span>
      </div>

      <div class="frp-grid">
        <button
          *ngFor="let day of calendarDays"
          type="button"
          class="frp-day"
          [class.frp-day--muted]="!inMonth(day)"
          [class.frp-day--selected]="
            mode === 'date' &&
            selectedDate &&
            strip(day).getTime() === strip(selectedDate).getTime()
          "
          [class.frp-day--range]="isInRange(day)"
          [class.frp-day--start]="isStart(day)"
          [class.frp-day--end]="isEnd(day)"
          [class.frp-day--disabled]="isDisabled(day)"
          [disabled]="isDisabled(day)"
          (click)="!isDisabled(day) && pickDate(day)"
        >
          {{ day.getDate() }}
        </button>
      </div>
    </div>

    <p *ngIf="showInlineValidation && validate().error" class="frp-error">
      {{ validate().error }}
    </p>

    <div *ngIf="showActions" class="frp-actions">
      <button type="button" class="frp-clear" (click)="clear()">Clear</button>
      <button type="button" class="frp-apply" [disabled]="!canApply" (click)="apply()">
        Apply
      </button>
    </div>
  </div>
</div>

<!-- MONTHLY MODE -->
<div *ngIf="mode === 'monthly'" class="frp-monthly">
  <div class="frp-month-year">
    <button type="button" class="frp-nav" (click)="prevYear()">‹</button>

    <div class="frp-title">
      {{ selectedYear }}
    </div>

    <button type="button" class="frp-nav" (click)="nextYear()">›</button>
  </div>

  <div class="frp-month-grid">
    <button
      *ngFor="let m of monthLabels; let i = index"
      type="button"
      class="frp-month"
      [class.frp-month--active]="selectedMonth === i + 1"
      (click)="selectMonth(i)"
    >
      {{ m }}
    </button>
  </div>
</div>
